<template>
  <div class="container-fluid py-4 px-4">
    <!-- ENCABEZADO -->
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-building display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            REGISTRO DE
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            EMPRESAS
          </p>
        </div>
      </div>
    </div>

  

    <div class="row g-2">
     
      <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

          <div class="d-flex justify-content-between align-items-center mb-3">

            <i class="bi bi-building-fill-add  text-dark display-6"></i>

           
            <div>
              <button v-if="VisalizarEditarEmpresa" class="btn btn-success px-3 py-2 shadow-sm rounded-3"
                title="Guardar cambios">
                <i class="bi bi-save-fill"></i>
              </button>
              <button v-else @click="VisalizarEditarEmpresa = true"
                class="btn btn-success px-3 py-2 shadow-sm rounded-3" title="Editar empresa">
                <i class="bi bi-pencil-square"></i>
              </button>
            </div>
          </div>

         
          <div>
            <h5 class="mt-2 mb-2 card-title">
              {{ VisalizarEditarEmpresa ? 'EDITAR EMPRESA' : 'NUEVA EMPRESA' }}
            </h5>

            <p class="mb-3 text-muted">
              {{ VisalizarEditarEmpresa ? 'Modifica la empresa seleccionada' : 'Ingresa el nombre de la nueva empresa'
              }}
            </p>
          </div>

        
          <div class="mb-3">
            <input v-if="VisalizarEditarEmpresa" type="text" class="form-control" v-model="editarEmpresa"
              placeholder="--EDITAR EMPRESA--" />
            <input v-else @keyup.enter="SubirEmpresa" type="text" class="form-control" v-model="nombreEmpresa"
              placeholder="EMPRESA" />
          </div>

         
          <div>
            <select class="form-select"
              @change="VisalizarEditarEmpresa ? SelectorEmpresa($event) : EmpresaParams($event)">
              <option disabled selected>
                {{ VisalizarEditarEmpresa ? '--EDITAR EMPRESA--' : 'SELECCIONAR EMPRESA' }}
              </option>
              <option v-for="(empresas, index) in empresa" :key="index" :value="index">
                {{ empresas.empRazSocial }}
              </option>
            </select>
          </div>

        </div>
      </div>
     
     <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

          <div class="d-flex justify-content-between align-items-center mb-3">

            <i class="bi bi-building-fill-add text-dark display-6"></i>

            <div>
              <button v-if="VisualizarEditarCC" class="btn btn-success px-3 py-2 shadow-sm rounded-3"
                title="Guardar cambios">
                <i class="bi bi-save-fill"></i>
              </button>
              <button v-else @click="VisualizarEditarCC = true" class="btn btn-success px-3 py-2 shadow-sm rounded-3"
                title="Editar centro de costos">
                <i class="bi bi-pencil-square"></i>
              </button>
            </div>
          </div>

         
          <div>
            <h5 class="mt-2 mb-2 card-title">
              {{ VisualizarEditarCC ? 'EDITAR CENTRO DE COSTOS ' : 'NUEVO CENTRO DE COSTOS DE LA EMPRESA' }}
            </h5>
            <p class="mb-3 text-muted">
              {{ VisualizarEditarCC ? 'Modifica el centro de costos seleccionado' : 'Ingresa un nuevo centro de costos'
              }}
            </p>
          </div>

       
          <div class="mb-3">
            <input v-if="VisualizarEditarCC" type="text" class="form-control" v-model="editarCentroCosto"
              placeholder="EDITAR CENTRO DE COSTOS" />
            <input v-else @keyup.enter="SubirCentroCosto" type="text" class="form-control" v-model="nombreCen"
              placeholder="CENTRO DE COSTOS" />
          </div>

         
          <div>
            <select class="form-select" @change="VisualizarEditarCC ? SelectorCC($event) : CentroCostoParams($event)">
              <option disabled selected>SELECCIONAR CC</option>
              <option v-for="(CentroCostos, index) in CentroCosto" :key="index" :value="index">
                {{ CentroCostos.cenNombre }}
              </option>
            </select>
          </div>

        </div>
      </div>
    
      <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

          <div class="d-flex justify-content-between align-items-center mb-3">
            <i class="bi bi-building-fill-add text-dark display-6"></i>
          
            <div>
              <button class="btn btn-success px-3 py-2 shadow-sm rounded-3" @click="SubirSubCentro">
                <i class="bi bi-save-fill"></i>
              </button>
            </div>
          </div>

          
          <div>
            <h5 class="mt-2 mb-2 card-title">NUEVO SUB CENTRO DE COSTOS</h5>
            <p class="mb-3 text-muted">Ingresa un sub centro de costos asociado a un centro de costos principal.</p>
          </div>

         
          <div class="mb-3">
            <input @keyup.enter="SubirSubCentro" type="text" class="form-control" v-model="nombreSubCen"
              placeholder="SUB CENTRO DE COSTOS" />
          </div>

         
          <div>
            <select class="form-select" @change="SubCentroCostoParams($event)">
              <option disabled selected>SELECCIONAR CC</option>
              <option v-for="(SubCentroCostos, index) in SubCentroCosto" :key="index" :value="index">
                {{ SubCentroCostos.cenNombre }}
              </option>
            </select>
          </div>

        </div>
      </div>

    
      <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

        
          <div class="d-flex justify-content-between align-items-center mb-3">
            <i class="bi bi-building-fill-add text-dark display-6"></i>
            <div>
              <button class="btn btn-success px-3 py-2 shadow-sm rounded-3" @click="SubirSubSubCentro">
                <i class="bi bi-save-fill"></i>
              </button>
            </div>
          </div>

          <!-- TITULO Y DESCRIPCION -->
          <div>
            <h5 class="mt-2 mb-2 card-title">NUEVO SUB SUB CENTRO DE COSTOS</h5>
            <p class="mb-3 text-muted">Ingresa un sub sub centro de costos asociado a un sub centro de costos.</p>
          </div>

          <!-- INPUT -->
          <div class="mb-3">
            <input @keyup.enter="SubirSubSubCentro" type="text" class="form-control" v-model="nombreSubSubCen"
              placeholder="SUB SUB CENTRO DE COSTOS" />
          </div>

          <!-- SELECT -->
          <div>
            <select class="form-select" @change="SubCentroCostoParams($event)">
              <option disabled selected>SELECCIONAR SSCC</option>
              <option v-for="(SubSubCentroCostos, index) in SubSubCentroCosto" :key="index" :value="index">
                {{ SubSubCentroCostos.cenNombre }}
              </option>
            </select>
          </div>

        </div>
      </div>

    </div>
  </div>

</template>


<script>
// import vSelect from 'vue-select'

export default {
  name: "SolimanologInsertarEmpXcc",
  components: {
    // vSelect
  },

  data() {
    return {
      empresa: [],
      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      idEmpresa: "",
      idCentro: "",
      idSubCentro: "",
      cenCodigo: "",
      cenSubCodigo: "",
      nombreEmpresa: "",
      nombreCen: "",
      nombreSubCen: "",
      nombreSubSubCen: "",

      editarEmpresa: "",
      editarCentroCosto: "",
      editarSubCentroCosto: "",
      VisalizarEditarEmpresa: false,
      VisualizarEditarCC: false,
      VisualizarEditarSCC: false
    };
  },
  mounted() {
    this.axios.get(`Empresa/ListaEmpresa`).then((r) => {
      this.empresa = r.data;
    });
  },
  methods: {
    EmpresaParams(event) {
      console.log(this.empresa[event.target.value].id);
      this.idEmpresa = this.empresa[event.target.value].id;
      this.axios
        .get(`Ccosto/ObtenerCcosto?idEmpresa=${this.idEmpresa}`)
        .then((r) => {
          console.log(r.data);
          this.CentroCosto = r.data;
        });
    },

    CentroCostoParams(event) {
      this.cenCodigo = this.CentroCosto[event.target.value].cenCodigo;
      this.idCentro = this.CentroCosto[event.target.value].idCentro;
      this.axios
        .get(
          `SubCentro/ObtenerSubCentro?idEmpresa=${this.idEmpresa}&codCenCosto=${this.cenCodigo}`
        )
        .then((r) => {
          console.log(r.data);
          this.SubCentroCosto = r.data;
        });
    },

    SubCentroCostoParams(event) {
      this.cenSubCodigo = this.SubCentroCosto[event.target.value].cenSubCodigo;
      this.idSubCentro = this.SubCentroCosto[event.target.value].id;

      this.axios
        .get(
          `SubSubCentro/ObtenerSubSubCentro?idEmpresa=${this.idEmpresa}&codCentro=${this.cenCodigo}&codSubCentro=${this.cenSubCodigo}`
        )
        .then((r) => {
          console.log(r.data);
          this.SubSubCentroCosto = r.data;
        });
    },

    SubirCentroCosto() {
      const from = {
        idEmpresa: this.idEmpresa,
        nombreCenCosto: this.nombreCen,
      };

      this.axios
        .post(`Ccosto/RegistrarCenCosto`, from)
        .then((r) => {
          console.log(r.data);
          console.log(from);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    SubirSubCentro() {
      const from = {
        idEmpresa: this.idEmpresa,
        cenCodigo: this.cenCodigo,
        cenNombre: this.nombreSubCen,
        idCentro: this.idCentro,
      };
      this.axios.post(`SubCentro/RegistrarSubCentro`, from).then((r) => {
        console.log(r.data);
      });
    },

    SubirSubSubCentro() {
      const from = {
        idEmpresa: this.idEmpresa,
        cenCodigo: this.cenCodigo,
        cenSubCodigo: this.cenSubCodigo,
        cenSubSubNombre: this.nombreSubSubCen,
        idSubCentro: this.idSubCentro,
      };
      this.axios.post(`SubSubCentro/RegistrarSubSubCentro`, from).then((r) => {
        console.log(r.data);
        console.log(from);
      });
    },

    // EditarEmpresas() {
    //   this.VisalizarEditarEmpresa = true;
    // },

    SelectorEmpresa(event) {
      this.editarEmpresa = this.empresa[event.target.value].empRazSocial;
      console.log(this.empresa[event.target.value].id);
      this.axios
        .get(`Ccosto/ObtenerCcosto?idEmpresa=${this.empresa[event.target.value].id}`)
        .then((r) => {
          console.log(r.data);
          this.CentroCosto = r.data;
        });
    },

    SelectorCC(event) {
      console.log(this.CentroCosto[event.target.value].idCentro)
      console.log(this.CentroCosto[event.target.value].cenNombre)
      this.editarCentroCosto = this.CentroCosto[event.target.value].cenNombre


    }
  },
};
</script>


<style scoped>
.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}
</style>
